import { Row, Form, Col, Input, Select, SelectOption } from "@ir/ui";

const DotfoodsPrmFormContent = ({
  getIssueCategories,
  isDisputeTypesLoading,
}: {
  getIssueCategories: () => SelectOption[];
  isDisputeTypesLoading: boolean;
}) => {
  return (
    <Row>
      <Col span={12} md={6}>
        <Form.Item name="disputeType" rules={[{ required: true, message: "Dispute Type is required." }]} label="Dispute Type">
          <Select
            maxMenuHeight={150}
            className="select-field"
            placeholder="Select"
            options={getIssueCategories()}
            isClearable={false}
            isLoading={isDisputeTypesLoading}
          />
        </Form.Item>
      </Col>
      <Col span={12} md={6}>
        <Form.Item name="disputeAmount" rules={[{ required: true, message: "Dispute Amount is required." }]} label="Dispute Amount">
          <Input type="number" step="0.01" placeholder="Enter dispute amount" />
        </Form.Item>
      </Col>
    </Row>
  );
};
export default DotfoodsPrmFormContent;
